export const StepTypes = {
	IntroStep: 1,
	GeneralStep: 2,
	GenreStep: 3,
	ExclusiveStep: 4,
	FinalStep: 5,
};
